import { defineStore } from 'pinia'
import { authService } from '@/services/authService'
import errorService from '@/services/errorService';
import { useImageTemplateStore } from '@/stores/ImageTemplateStore';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: {
      dark: 0
    },
    token: null,
    isAuthenticated: false,
    forceLogout: false,
    notifications: {},
    invitation: null,
    banks: [],
  }),

  actions: {
    async login(credentials) {
      try {
        const response = await authService.login(credentials);
        this.user = response.data.data;
        this.isAuthenticated = true;
        this.forceLogout = false;
        localStorage.setItem('auth_token', response.data.data.token);

        return { success: true };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },

    async recovery(credentials) {
      try {
        await authService.recovery(credentials);

        return { success: true };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },

    async changePassword(params) {
      try {
        await authService.changePassword(params);

        return { success: true };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },
    
    async checkLogin() {
      if(this.forceLogout == true){
        this.isAuthenticated = false;
        return;
      }
      if(this.isAuthenticated == true && this.forceLogout == false){
        return { success: true };
      }
      try {
        const response = await authService.checkLogin();
        this.user = response.data.data;
        this.isAuthenticated = true;

        return { success: true };
      }
      catch (error) {
        this.user = null;
        this.isAuthenticated = false;

        return errorService.handle(error);
      }
    },

    async checkNotifications() {
      try {
        const response = await authService.checkNotifications();
        this.notifications = response.data;

        return { success: true };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },

    async logout() {
      try {
        this.forceLogout = true;
        this.isAuthenticated = false;

        authService.logout();

        /* Modelos ficam em cache na sessão; sem isso o próximo login veria os do usuário anterior. */
        useImageTemplateStore().$reset();

        return { success: true };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },

    async getInvitation(code) {
      try {
        const response = await authService.getInvitation(code);
        
        this.invitation = response.data;
        this.banks = response.data.banks || [];

        return { success: true };
      }
      catch (error) {
        this.invitation = null;
        this.banks = [];
        
        return errorService.handle(error);
      }
    },

    async registerInvitation(userData) {
      try {
        await authService.registerInvitation(userData);

        return { success: true };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },
  },
});